import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import type { UpdateClientEmailRequest } from 'src/types/email_notifications';
import axiosInstance from 'src/utils/axios';

interface UpdateNotificationEmailParams {
  contactMethodId: string;
  email: string;
}

const useUpdateNotificationEmailMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ contactMethodId, email }: UpdateNotificationEmailParams) => {
      const body: UpdateClientEmailRequest = { email };
      await axiosInstance.put(api.updateNotificationEmail(contactMethodId), body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.client.notificationEmails() });
    },
  });
};

export default useUpdateNotificationEmailMutation;
